<template>
    <div>
        <div class="ui modal" style="padding: 20px;">
            <div class="ui grid">
                <div class="eight wide column">
                    <div class="header"><h1>{{ $t("navbar.settings") }}</h1></div>
                </div>
                <div class="eight wide column" style="text-align: right;">
                    <div v-on:click='closeSettings' style="cursor: pointer;"><i class="close big icon" ></i></div>
                </div>
            </div>
            <div class="ui grid">
                <div class="four wide column">
                    <div class="ui secondary vertical menu">
                      <a id="TabAccount" class="active item" data-tab="tab-account" v-on:click='selectedTabAccount'>
                        {{ $t("navbar.account") }}
                      </a>
                      <a id="TabContacts" class="item" data-tab="tab-contacts" v-on:click='selectedTabContacts'>
                        {{ $t("navbar.contacts") }}
                      </a>
                      <!--<a id="TabDisplay" class="item" data-tab="tab-display" v-on:click='selectedTabDisplay'>
                        Display
                      </a>-->
                    </div>
                </div>
                <div class="twelve wide column">
                    <div style="padding: 20px">
                        <!-- ACCOUNT -->
                        <div v-if="settingsTab == 'account'">
                            <h2> {{ $t("navbar.account") }} </h2>
                            <p> {{$t("changepassword.desc")}} </p>
                            <div class="ui fluid input">
                                <input type="password" v-model="password.oldp" v-on:update-value="updateOldUserPassword" :placeholder='$t("changepassword.old")' style="margin-top: 20px;"><br><br>
                            </div>
                            <div class="ui fluid input">
                                <input type="password" v-model="password.newp" v-on:update-value="updateNewUserPassword" :placeholder='$t("changepassword.new")' style="margin-top: 20px;"><br><br>
                            </div>
                            <div class="ui fluid input">
                                <input type="password" v-model="password.newpc" v-on:update-value="updateNewUserPasswordCheck" :placeholder='$t("changepassword.repeat")' style="margin-top: 20px;"><br><br>
                            </div>
                            <button class="ui tiny gray button" v-on:click='changepassword' style="margin-top: 15px;">{{$t("changepassword.change")}}</button>
                            <transition name="fade" mode="out-in">
                                <div v-if="nonvaliddata == true">
                                    <br>
                                    <div class="ui negative message">
                                        <div class="header">
                                            <p>{{ $t("changepassword.negative") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <transition name="fade" mode="out-in">
                                <div v-if="validresponse == true">
                                    <br>
                                    <div class="ui positive message">
                                        <div class="header">
                                            <p>{{ $t("changepassword.positive") }}</p>
                                        </div>
                                        <p></p>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <!-- CONTACTS -->
                        <div v-if="settingsTab == 'contacts'">
                            <h2> {{ $t("navbar.contacts") }} </h2>
                            <labelinput v-model="contacts.tel" v-on:update-value="updateTel" :label='$t("changecontacts.tel")' style="margin-top: 35px;"></labelinput><br><br>
                            <labelinput v-model="contacts.mob" v-on:update-value="updateMobTel" :label='$t("changecontacts.mob")'></labelinput><br><br>
                            <labelinput v-model="contacts.email" v-on:update-value="updateEmail" :label='$t("changecontacts.email")'></labelinput><br><br>
                            <button class="ui tiny gray button" v-on:click='changecontacts'>{{$t("changecontacts.change")}}</button>
                            <transition name="fade" mode="out-in">
                                <div v-if="nonvaliddata == true">
                                    <br>
                                    <div class="ui negative message">
                                        <div class="header">
                                            <p>{{ $t("changecontacts.negative") }}</p>
                                        </div>
                                        {{this.responsedata.lde_message}}
                                    </div>
                                </div>
                            </transition>
                            <transition name="fade" mode="out-in">
                                <div v-if="validresponse == true">
                                    <br>
                                    <div class="ui positive message">
                                        <div class="header">
                                            <p>{{ $t("changecontacts.positive") }}</p>
                                        </div>
                                        <p></p>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <!-- DISPLAY -->
                        <div v-if="settingsTab == 'display'">
                            <h2> Display </h2>
                            <p> Tema </p>
                            <div class="ui tiny orange button" v-on:click="setTheme('amour')">Amour</div>
                            <div class="ui tiny blue button" v-on:click="setTheme('blue')">Blu</div>
                            <div class="ui tiny black button" v-on:click="setTheme('black')">Nero</div>
                            <div class="ui tiny button" v-on:click="setTheme('gray')">Grigio</div>
                            <div class="ui tiny green button" v-on:click="setTheme('green')">Verde</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import router from '../router'
import labelinput from '@/components/textinput.vue'
import theme from '@/components/theme.js'

const $ = require('jquery')
window.$ = $

export default {
    props: ['user'],
    name: 'settingspage',
    data: function () {
        return {
            settingsTab: 'account',
            password: {"oldp": "", "newp": "", "newpc": ""},
            contacts: {"tel": "", "mob": "", "email": ""},
            nonvaliddata: false,
            validresponse: false,
            imagelogin: "",
            responsedata: ""
        }
    },
    components: {
        labelinput
    },
    methods: {
        closeSettings: function () {
            $('.ui.modal').modal('hide')
        },
        selectedTabAccount: function () {
            $('#TabDisplay').removeClass('active')
            $('#TabContacts').removeClass('active')
            $('#TabAccount').addClass('active')
            this.settingsTab = 'account'
        },
        selectedTabContacts: function () {
            $('#TabDisplay').removeClass('active')
            $('#TabAccount').removeClass('active')
            $('#TabContacts').addClass('active')
            this.settingsTab = 'contacts'  
        },
        selectedTabDisplay: function () {
            $('#TabContacts').removeClass('active')
            $('#TabAccount').removeClass('active')
            $('#TabDisplay').addClass('active')
            this.settingsTab = 'display'
        },
        changepassword: function() {
            this.validresponse = false;
            this.nonvaliddata = false;
            $.post(this.baseUrl + "/changepassword", this.password, function(data) { 
                if (data["response"] == true) {
                    this.validresponse = true;
                } else {
                    this.nonvaliddata = true;
                    this.responsedata = data["responsedata"];

                }
            }.bind(this));
        },
        updateOldUserPassword: function(val) {
            this.password.oldp = val;
        },
        updateNewUserPassword: function(val) {
            this.password.newp = val;
        },
        updateNewUserPasswordCheck: function(val) {
            this.password.newpc = val;
        },
        changecontacts: function() {
            this.validresponse = false;
            this.nonvaliddata = false;
            $.post(this.baseUrl + "/changecontacts", this.contacts, function(data) { 
                if (data["response"] == true) {
                    this.validresponse = true;
                } else {
                    this.nonvaliddata = true;
                    this.responsedata = data["responsedata"];
                }
            }.bind(this));
        },
        updateTel: function(val) {
            this.contacts.tel = val;
        },
        updateMobTel: function(val) {
            this.contacts.mob = val;
        },
        updateEmail: function(val) {
            this.contacts.email = val;
        },
        setTheme: function (val) {
            theme.setTheme(true, val)
            //document.cookie = "ssotheme=" + val + "; expires=Thu, 31 Dec 2020 17:00:00 UTC; path=/";
        }
    },
    beforeMount: function () {
        $.post(this.baseUrl + "/isauth", function(data) { 
            if (data["response"] != true) {
                router.push({name: 'login'} );    
            }
            $.getJSON(this.baseUrl + "/contacts", function(data) { 
                this.contacts.tel = data.telephoneNumber;
                this.contacts.mob = data.mobile;
                this.contacts.email = data.mail;
            }.bind(this))
        }.bind(this));
    },
    mounted: function () {

    },
    updated: function () {
        
    }
}
</script>

<style lang="scss">
@import "@/style/comon.scss";

#ServicesPage {
    @extend %mainbackground;
    min-height: 100vh; 
}
#Servicesbar {
    
}
</style>
